export default {
  SET_CONTACTS: "SET_CONTACTS",
  SET_PACKAGE: "SET_PACKAGE",
  SET_BALANCE: "SET_BALANCE",
  SET_LAST_INVOICE: "SET_LAST_INVOICE",
  SET_INVOICES: "SET_INVOICES",
  SET_SERVICES: "SET_SERVICES",
  SET_PRODUCTS: "SET_PRODUCTS",
  SET_USER: "SET_USER",
  SET_PACKAGES: "SET_PACKAGES",
};